export default __webpack_public_path__ + "static/media/thumb-Nacic-Clock-2.fd911c87.png";